import { assignment } from '@axo/shared/data-access/types';
import { IAPI } from '../../lib/models/api';

export function putAssignee({ url: { service: baseURL }, token }: IAPI) {
  return async function putAssignee({
    country,
    user,
    input,
  }: {
    country: string;
    user: string;
    input: assignment.UpdateAvailabilityInput;
  }): Promise<assignment.Assignment> {
    const url = new URL(`/assignment/assignee/${country}/${user}`, baseURL);
    try {
      const response = await fetch(url, {
        method: 'PUT',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify(input),
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return await response.json();
    } catch {
      throw new Error('Failed to update availability status');
    }
  };
}
